import { Box, CircularProgress, Typography } from '@material-ui/core'
import React from 'react'
import ErrorIcon from '@material-ui/icons/Error'
import { Indicator } from '../../../../types'

export function ErrorIndicator(props: { indicator: Indicator<string> }) {
  const { indicator } = props
  if (indicator.fetching) {
    return (
      <Box className='flexEnd'>
        <CircularProgress size={25} />
      </Box>
    )
  } else if (indicator.value && indicator.value.length > 0) {
    return (
      <Box className='flexCenter'>
        <Typography className='margin-right' variant='body1'>
          {indicator.value}
        </Typography>
        <ErrorIcon />
      </Box>
    )
  }
  return null
}
